import React, {useState} from "react";
import {VacatureModel} from "../../pages/api/vacature.model";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSort} from "@fortawesome/free-solid-svg-icons";

interface TotalAmountProps {
    vacatures: VacatureModel[];
    sortBy: string;
    sortableBy: string[];
    sortChanged: (sortBy) => void;
}

const TotalAmount: React.FC<TotalAmountProps> = ({vacatures, sortBy, sortableBy, sortChanged}) => {

    const [show, setShow] = useState(false);

    const toggle = () => {
        setShow(!show);
    };

    const onClick = (sortBy) => {
        setShow(false);
        sortChanged(sortBy);
    }

    return (
        <>
            <div className="filters-products d-flex justify-content-between flex-wrap">
                <strong className="text-body-lead color-gray-500">
                    <span className="color-green-900">{vacatures.length}</span> vacatures
                </strong>
                <div className="dropdown text-lg-end text-md-end text-startmt-sm-15">
                    <strong onClick={toggle} className="text-body-lead color-gray-500 pointer">
                        <FontAwesomeIcon icon={faSort}/>{" "}Sorteer op:{" "}<span
                        className="color-green-900">{sortBy}</span>
                    </strong>
                    {show && <ul className="dropdown-menu show py-2" aria-labelledby="dropdownButton">
                        {sortableBy.map((s, index) => <>
                            <li key={index}>
                                <a className={`${s === sortBy ? "active" : ""} dropdown-item`}
                                   onClick={() => onClick(s)}>{s}</a>
                            </li>
                        </>)}
                    </ul>}
                </div>
            </div>
        </>
    );
};

export default TotalAmount;
